import React, { useEffect, useState } from 'react'
import PhoneInput from './PhoneInput'
import { useTranslation } from 'react-i18next'

interface MyPhoneNumberProps {
  value: string
  onChange: (value: string) => void
  onCountryChange: (value: string) => void
  countryCode: string
  isInvalid?: boolean
  error?: string
  isPhoneConfirmed?: boolean
}

const MyPhoneNumber: React.FC<MyPhoneNumberProps> = ({
  value,
  onChange,
  onCountryChange,
  countryCode,
  isInvalid,
  error,
  isPhoneConfirmed,
}) => {
  const { t } = useTranslation()
  const [inputClass, setInputClass] = useState(
    value ? 'bg-grisclair' : 'bg-redlight',
  )

  useEffect(() => {
    setInputClass(!value ? 'bg-redlight rounded-md' : '')
  }, [value])

  return (
    <PhoneInput
      value={value}
      onChange={onChange}
      onCountryChange={onCountryChange}
      isInvalid={isInvalid}
      error={error}
      isPhoneConfirmed={isPhoneConfirmed}
      className={`${inputClass} transition-colors duration-300`}
    />
  )
}

export default MyPhoneNumber
